/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Suspense } from "react";
import Loader from "./Loader";

// eslint-disable-next-line
const Loadable = (Component) => (props) =>
    (
        <Suspense fallback={<Loader />}>
            <Component {...props} />
        </Suspense>
    );


Loadable.displayName = "Loadable";
export { Loadable };
